import { camelToSnakeCase } from "../../utils/utils";

export const PATIENTS_SORT_FIELD_MAP: Record<string, string> = {
  name: "wieldy_first_name",
  dob: "patient_dob",
};

export const PATIENT_FILTER_FIELD_MAP: Record<string, string> = {
  dob: "patient_dob",
  last_claim_date: "wieldy_claim_date",
  last_payment_date: "payment_date",
};

export function mapPatientSortField(frontendField: string): string {
  if (frontendField in PATIENTS_SORT_FIELD_MAP) {
    return PATIENTS_SORT_FIELD_MAP[frontendField];
  }
  return camelToSnakeCase(frontendField);
}

export function mapPatientFilterField(frontendField: string): string {
  const snakeCase = camelToSnakeCase(frontendField);
  if (snakeCase in PATIENT_FILTER_FIELD_MAP) {
    return PATIENT_FILTER_FIELD_MAP[snakeCase];
  }
  return snakeCase;
}
